import React from 'react';
import { TextField, InputLabel } from '@material-ui/core';
import { formatDateString } from '../../utils/dates';

/**
 * @param {string} inputLabel - The label displayed above the input
 * @param {Object} inputValue - The selected date in Modern Calendar format ({ year, month, day })
 * @param {boolean} error - If true, the label will be displayed in an error state
 * @param {string} errorMessage - Optional helper text to show error messages
 * @param {Object} ref - The ref forwarded by react-modern-calendar-datepicker
 *
 * @returns {JSX.Element}
 */
const CustomInputField = React.forwardRef(({
  inputLabel,
  inputValue,
  error,
  errorMessage
}, ref) => {
  return (
    <>
      <InputLabel>
        {inputLabel}
      </InputLabel>
      <TextField
        className="date-range-picker-input"
        fullWidth
        variant="standard"
        inputRef={ ref }
        InputProps={ {
          readOnly: true
        } }
        value={ inputValue ? formatDateString(inputValue) : '' }
        error={ error }
        helperText={ errorMessage }
      />
    </>
  );
});

export default CustomInputField;
